<template>
  <div class="MonitorLiveList ">
    <div class="carrier-list-data">
      <div class="this-day-live-summary">
        共有
        <span class="number-font">{{ anchorNum }}</span>
        位达人，直播
        <span class="number-font">{{ info.length || 0 }}</span>
        场，销售总额
        <span class="number-font sales">¥ {{ $retainWan(liveSales) }}</span>
      </div>
    </div>
    <template v-if=" info.length">
      <div v-for="streamer of group" class="streamer">
        <div class="header align">
          <router-link :to="`/anchor/${$_.get(streamer,'[0].anchor.id')}?banner=2`">
            <img :src="$_.get(streamer,'[0].anchor.avatar')" alt="avatar" class="avatar">
          </router-link>
          <router-link :to="`/anchor/${$_.get(streamer,'[0].anchor.id')}?banner=2`">
            <div class="name oneLine">{{ $_.get(streamer, '[0].anchor.name') }}</div>
            <div class="info">
              直播
              <span class="number-font">{{ streamer.length }} 场</span>
              ，累计时长
              <span class="number-font">{{ formatDuration(streamer) }}</span>
            </div>
          </router-link>
          <span v-if="showSales(streamer, 'sales')" class="btn" @click.stop="goShare(streamer)">生成战报</span>
        </div>
        <!--统计行-->
        <div class="statistic around">
          <!--销售额-->
          <div class="money-statistics" @click="openPopup('Goods', streamer)">
            <div class="text">销售额</div>
            <div v-if="showSales(streamer,'sales')" class="number-font orange">
              <span v-if="true" style="font-size: .2rem">¥</span>
              {{ $retainWan(showSales(streamer, 'sales')) }}
            </div>
            <div v-else style="font-size:.36rem">未卖货</div>
            <div class="btn">
              销售详情
              <van-icon name="arrow" style="vertical-align: top" />
            </div>
          </div>
<!--          &lt;!&ndash;礼物收入&ndash;&gt;-->
<!--          <div class="money-statistics" @click="openPopup('Income', streamer)">-->
<!--            <div class="text">礼物收入</div>-->
<!--            <div class="number-font">-->
<!--              <span style="font-size: .2rem">¥</span>-->
<!--              {{ $kuaibiCoin(showSales(streamer, 'receiveGift')) }}-->
<!--            </div>-->
<!--            <div class="btn">-->
<!--              收礼详情-->
<!--              <van-icon name="arrow" style="vertical-align: top" />-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;对外打赏&ndash;&gt;-->
<!--          <div class="money-statistics" @click="openPopup('Expend', streamer)">-->
<!--            <div class="text">对外打赏</div>-->
<!--            <div class="number-font">-->
<!--              <span v-if="true" style="font-size: .2rem">¥</span>-->
<!--              {{ isVIP ? $kuaibiCoin(showSales(streamer, 'sendGift')) : '****' }}-->
<!--            </div>-->
<!--            <div class="btn">-->
<!--              打赏详情-->
<!--              <van-icon name="arrow" style="vertical-align: top" />-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <!--单场直播block-->
        <div v-for="live of streamer" :key="live.id" class="live" @click="goLive(live)">
          <!--毛玻璃-->
          <img
            class="frosted-glass"
            :src="$changeCDN(live.poster) || placeholder"
            :onerror="onerror"
          />
          <div class="content">
            <span class="text din">
              <div class="line">{{ $formatTime(live.startTime * 1000, 'HH:mm') }} 开播</div>
              <div class="line">{{ formatDuration([live]) }}</div>
              <div class="line title">{{ live.title }}</div>
              <div class="line">
                <template v-if="showSales([live],'sales')">
                  ¥{{ $retainWan(showSales([live], 'sales')) }}
                </template>
                <template v-else>未卖货</template>
              </div>
              <div>
                直播详情
                <van-icon name="arrow" style="vertical-align: top" />
              </div>
            </span>
            <img
              :src="$changeCDN(live.poster) || placeholder"
              class="cover"
              alt="cover"
              :onerror="onerror"
            />
          </div>
        </div>
      </div>
    </template>
    <NoneData v-else propsText="该日没有直播记录" :height="6" />
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '80%' }">
      <keep-alive>
        <component
          v-if="showPopup"
          :is="popupType"
          :liveStreamLog="liveStreamLog"
          @close="showPopup = false"
        />
      </keep-alive>
    </van-popup>
  </div>
</template>

<script>
import Goods from '@/modules/anchor/LiveCalendar/Goods';
import Income from '@/modules/anchor/LiveCalendar/Income';
import Expend from '@/modules/anchor/LiveCalendar/Expend';

export default {
  components: { Goods, Income, Expend },
  props: { info: Array },
  data() {
    return {
      showPopup: false,
      popupType: '',
      liveStreamLog: [],
      onerror: `this.src='https://s6.bihukankan.com/common/default.png'`
    }
  },
  computed: {
    isVIP() {
      return this.$store.state.userLevel && this.$store.state.userLevel <= 95
    },
    group() {
      const group = this.$_.groupBy(this.info, 'anchor.name')
      const result = []
      for (const key in group) {
        result.push(group[key])
      }
      result.sort((a, b) => this.showSales(b, 'sales') - this.showSales(a, 'sales'))
      return result
    },
    anchorNum() {
      return this.$_.uniq(this.info.map(ele => ele.anchorId)).length || 0;
    },
    liveSales() {
      return this.$sum(this.info.map(ele => ele.statistic.sales));
    }
  },
  methods: {
    formatDuration(arr) {
      let unix = 0
      for (const item of arr) {
        unix += item.stopTime - item.startTime
      }
      const hours = parseInt(unix / 3600);
      const minutes = parseInt(unix / 60) % 60;
      return hours ? `${hours}小时${minutes}分钟` : minutes + '分钟';
    },
    goShare(arr) {
      for (const item of arr) {
        item.sales = item.statistic.sales
      }
      this.$router.push({
        name: 'liveInfoShare',
        params: {
          anchorId: arr?.[0]?.anchor?.id,
          id: arr?.[0]?.anchor?.id,
          liveStreamLog: arr
        }
      });
    },
    showSales(arr, key) {
      let result = 0
      for (const item of arr) {
        result += Number(item?.statistic?.[key])
      }
      return result
    },
    openPopup(type, data) {
      // 开通年费会员
      if (!this.isVIP && type === 'Expend') {
        this.$store.commit('WRITEOVERLAYSHOW', {
          status: true,
          textChange: 'liveCalendarYear',
          yearVipOnly: { 0: true, 2: true }
        });
        return;
      }
      if (type === 'Goods' && !this.showSales(data, 'sales')) {
        this.$toast('该主播当日没有卖货');
        return;
      }
      if (type === 'Income' && !this.showSales(data, 'receiveGift')) {
        this.$toast('该主播当日没有收到礼物');
        return;
      }
      if (type === 'Expend' && !this.showSales(data, 'sendGift')) {
        this.$toast('该主播当日没有对外打赏');
        return;
      }
      this.popupType = type;
      data[0].date = this.$formatTime(data[0].startTime * 1000, 'YYYYMMDD')
      this.liveStreamLog = data;
      this.showPopup = true;
    },
    goLive(live) {
      this.$router.push({ path: `/live/${this.$_.get(live, 'anchor.id')}/${live.id}` });
    },
  }
};
</script>

<style lang="less" scoped>
.MonitorLiveList {
  .this-day-live-summary {
    background: #fff;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    color: #a1aebf;

    .number-font {
      color: #4a4a4a;
    }

    .number-font.sales {
      color: #ff5500;
    }
  }

  .streamer {
    width: 6.9rem;
    margin: .3rem auto;
    padding: 0 .2rem .2rem;
    background: #ffffff;
    box-shadow: 0 0.02rem 0.2rem 0 rgba(202, 211, 223, 0.5);
    border-radius: 0.16rem;

    .header {
      height: 1rem;
      border-bottom: .01rem solid #cad3df;

      .avatar {
        width: 0.8rem;
        height: 0.8rem;
        box-shadow: 0 0.04rem 0.1rem 0 rgba(54, 96, 146, 0.5);
        border-radius: 50%;
        object-fit: cover;
        margin-right: .1rem;
      }

      .name {
        width: 3.78rem;
        font-size: 0.36rem;
        font-weight: 600;
        color: #4a4a4a;
        line-height: 0.36rem;
      }

      .info {
        margin-top: .14rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #a1aebf;
        line-height: 0.24rem;

        .number-font {
          font-weight: bold;
        }
      }

      .btn {
        width: 1.5rem;
        height: 0.6rem;
        background: #ffffff;
        border-radius: 0.08rem;
        border: 0.01rem solid #ff9900;
        text-align: center;
        font-size: 0.28rem;
        line-height: .6rem;
        color: #ff9900;
        margin-left: auto;
      }
    }

    .money-statistics {
      font-size: 0.2rem;
      text-align: center;

      .text {
        color: #4a4a4a;
        margin: 0.3rem 0 0.2rem 0;
      }

      .number-font {
        font-size: 0.36rem;
        font-weight: bold;
        color: #4a4a4a;
      }

      .btn {
        color: #a1aebf;
        margin-top: 0.2rem;
      }

      .orange {
        color: #ff5500;
      }
    }

    .live {
      position: relative;
      width: 6.5rem;
      height: 2.6rem;
      overflow: hidden;
      margin-top: 0.35rem;

      .frosted-glass {
        width: 6.5rem;
        height: 2.6rem;
        filter: blur(0.1rem) brightness(70%);
        transform: scale(1.1);
      }

      .content {
        color: white;
        position: absolute;
        top: 0;
        z-index: 1;

        .text {
          display: inline-block;
          padding: 0.3rem 0.2rem;
          font-size: 0.2rem;
          width: 2.45rem;
          height: 2.6rem;

          .title {
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .line {
            margin-bottom: 0.2rem;
          }
        }

        .cover {
          width: 1.6rem;
          height: 2.6rem;
          vertical-align: top;
          object-fit: cover;
        }
      }
    }
  }

  .van-popup {
    background: #f2f1f8;
  }
}
</style>
